import { SignOut } from './SignOut';

export default SignOut;
